(ns ycweb.app.admin.wholesale.clientorders.clientorders
  (:require
   #?@(:clj
       [[clj-time.core :as dt]]
       :cljs
       [[cljs-time.core :as dt]])
   [rum.core :as rum]
   [ycweb.app.admin.wholesale.common :as w.cmn]
   [ycweb.app.admin.wholesale.clientorders.clientorder.common :as co.cmn]
   [ycweb.app.admin.wholesale.clientorders.clientorder.overview]
   [ycweb.app.dashboard.common :as dcommon]
   [ycweb.app.dashboard.presence :as presence]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.editor.base :as editor]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.date :as yud]
   [ycweb.util.urlstate :as urlstate]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]))

(defn client-order-edit-overview [app-atom _ _ v]
  (w.cmn/overview-link app-atom
    {:entity-uuid v
     :permission co.cmn/view-permission
     :action "client_order_overview"}))

(defn so-ref [_ _ _ v]
  (str "SO-" v))

(defn customer-addresses [app-atom input-atom config value]
  (let [action-atom (cmn/action-cursor app-atom)
        editor-atom (editor/editor-cursor app-atom :admin.wholesale/client-orders.editor)
        shipping-addresses (cmn/curact action-atom [:shipping-addresses-gpd (int (:id value))])
        billing-addresses (cmn/curact action-atom [:billing-addresses-gpd (int (:id value))])]
    (swap! editor-atom update :form
      (fn [form]
        (->
          form
          (update :client-order/customer_id assoc :value (:id value)))))

    (editor/post-comms app-atom :admin.wholesale/client-orders.editor
      {:options
       {:client-order/billing_address_id (or billing-addresses [])
        :client-order/shipping_address_id (or shipping-addresses [])}})))

(defn hide-reference-field [app-atom]
  (let [editor-atom (editor/editor-cursor app-atom :admin.wholesale/client-orders.editor)
        customers-idx
        (yuc/index-by :id
          (editor/get-field-options app-atom
            :admin.wholesale/client-orders.editor
            :client-order/customer_id))
        customer-id (cmn/curact editor-atom [:form :client-order/customer_id :value])
        customer (get customers-idx customer-id)]
    (not= (:uuid customer) co.cmn/es-yuppiechef-customer-uuid)))

(defn editor-open-event [app-atom editor-atom mode]
  (let [process-atom (cmn/process-cursor app-atom)
        form-atom (rum/cursor editor-atom :form)
        company-id (cmn/curact process-atom :company/id)]

    (when (not= mode :remove)
      (swap! form-atom update :client-order/company_id assoc :value company-id))))

(defn pre-submit-fn [app-atom _editor-atom _mode]
  {:action-key :admin.wholesale/client-orders.multi-cancel})

(defn client-order-table-fns [_]
  {:editor
   {:event-fns
    {:open-fn editor-open-event
     :pre-submit-fn pre-submit-fn}
    :form
    {:fields
     {:client-order/description
      {:hidden-fn (partial hide-reference-field)}
      :client-order/customer_id
      {:select-fn customer-addresses}}}}
   :column-fns
   {:edit-fn client-order-edit-overview
    :so-ref-fn so-ref}
   :config-fns
   {:row-class-fn
    (fn [_app-atom row]
      (let [tags (map :name (:client-order/tags row))
            override (some #{"Override"} tags)]
        (yuc/bem :row-status [(when override :is-warning)])))}})

(defn client-order-table-config [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        action-name (cmn/process-action-name app-atom)
        dear-sync (cmn/curact process-atom :dear-sync/method)
        multi-cancel-permission?
        (cmn/has-any-permission? app-atom
          ["SiteAdmin:Teams:Development" "SiteAdmin:Wholesale:ClientOrder:MultiCancel"])

        reconcile-permission?
        (cmn/has-any-permission? app-atom
          ["SiteAdmin:Teams:Development" "SiteAdmin:Wholesale:ClientOrder:MultiCancel"])

        create-cfg
        (cond
          (= dear-sync :pull)
          {:text "Create client order"
           :action :admin.wholesale/wholesale.editor-disabled
           :extends :create}

          :else
          {:text "Create client order"
           :editor :admin.wholesale/client-orders.editor
           :extends :create})

        reconcile-report
        (when reconcile-permission?
          {:text "Reconcile Report"
           :action :admin.wholesale/client-orders.open-reconcile-modal})

        cancel-cfg
        (when multi-cancel-permission?
          (cond
            (= dear-sync :pull)
            {:text "Cancel client order"
             :action :admin.wholesale/wholesale.editor-disabled
             :extends :remove}

            :else
            {:text "Cancel client order"
             :action :admin.wholesale/client-orders.cancel-order-reason
             :multi-select true
             :extends :remove
             :config {:text "Cancel"}
             :title "Cancel Order(s)?"
             :message "Are you are you want to cancel these orders?"}))]

    {:table-name :admin.wholesale/client-orders.table
     :row-id :client-order/id
     :row-class-k :row-class-fn
     :data-source
     {:cursor [action-name :client-orders]
      :action :admin.wholesale/client-orders.list
      :parameter-fn :entity-fn}
     :select? (if multi-cancel-permission? {:style :os} false)
     :options
     {:order :desc
      :sort-title "Date Added"
      :paging? true
      :pagination {:page 0 :page-size 20}}
     :buttons [create-cfg cancel-cfg :refresh reconcile-report]
     :column-defs
     [{:title "Order Number"
       :key :client-order/ref-id
       :render
       {:logic-k :so-ref-fn}
       :align-class :u-text-center}
      {:title "Date Added"
       :key :client-order/date-added
       :type :date
       :dateformat "dd/MM/yyyy"}
      {:title "Customer"
       :key :customer/name}
      {:title "Order Ref"
       :key :client-order/description}
      {:title "Invoice Number"
       :key :client-order/invoice-number}
      {:title "Date Shipped"
       :key :client-order/ship-date
       :type :date
       :dateformat "dd/MM/yyyy"
       :default "N/A"}
      {:title "Order Status"
       :key :client-order/order-status
       :align-class :u-text-right}
      {:title "Fulfilment Status"
       :key :client-order/fulfilment-status
       :align-class :u-text-right}
      {:title "Finance Status"
       :key :client-order/finance-status
       :align-class :u-text-right}
      {:title "Total"
       :key :client-order/total
       :type :tocurrency}
      {:title "Overview"
       :key :client-order/uuid
       :render {:render-k :edit-fn}
       :options {:ignore-row-click true}
       :align-class :u-text-center}]}))

(def editor-config
  {:editor-name :admin.wholesale/client-orders.editor
   :datatable :admin.wholesale/client-orders.table
   :mode :read
   :end-points
   {:create :admin.wholesale/client-orders.add-sale-order
    :remove :admin.wholesale/client-orders.cancel-sale-order}
   :fields
   [{:name :client-order/customer_id
     :label "Customer:"
     :type :select-search
     :attr
     {:placeholder "- Select A Customer -"
      :type :number}
     :opts-cfg {:lookup {:value :id :text :name}}}
    {:name :client-order/shipping_address_id
     :label "Shipping Address:"
     :type :select-search
     :attr
     {:placeholder "- Select A Shipping Address -"
      :type :number}
     :opts-cfg {:lookup {:value :id :text :line1}}}
    {:name :client-order/billing_address_id
     :label "Billing Address:"
     :type :select-search
     :attr
     {:placeholder "- Select A Billing Address -"
      :type :number}
     :opts-cfg {:lookup {:value :id :text :line1}}}
    {:name :client-order/description
     :label "Reference:"}
    {:name :client-order/warehouse_id
     :label "Warehouse:"
     :type :select
     :attr
     {:placeholder "- Select A Warehouse -"
      :type :number}
     :opts-cfg {:lookup {:value :id :text :name}}}
    {:name :client-order/company_id
     :attr {:type :hidden}}]})

(defmethod comms/receive :admin.wholesale/client-orders.add-sale-order [app-atom {:keys [msg rows] :as e}]
  (let [{:keys [success]} (editor/post-submit app-atom :admin.wholesale/client-orders.editor e)]
    (when success
      (let [client-order (first rows)]
        (cond
          (= (count rows) 1)
          (do
            (toaster/open-toast app-atom :success msg {})
            (urlstate/redirect app-atom "wholesale" "client_order_overview" {:uuid (:client-order/uuid client-order)}))

          :else
          (datatables/add-rows app-atom :admin.wholesale/client-orders.table e))))))

(defmethod grid/action :admin.wholesale/client-orders.cancel-order-reason [app-atom {:keys [selected-row-ids]} _]
  (grid/single-input-modal app-atom
    {:title "Multi-Cancel Orders"
     :text
     (str "Are you wish you wish you cancel "
       (if (= (count selected-row-ids) 1) "this" "these") " order"
       (when (> (count selected-row-ids) 1) "s"))
     :cancel-text "Cancel"
     :save-key :admin.wholesale/client-orders.cancel-order-submit
     :selected-row-ids selected-row-ids
     :input-key :cancel-reason
     :field-text "Reason"
     :auto-focus true}))

(defmethod grid/action :admin.wholesale/client-orders.cancel-order-submit [app-atom config _]
  (let [selected-row-ids (get-in config [:config :selected-row-ids])
        multi-cancel-reason (:cancel-reason config)]
    (datatables/overlay app-atom :open :admin.wholesale/client-orders.table)
    (comms/send :admin.wholesale/client-orders.cancel-sale-order
      {:action :remove
       :pre-submit-data
       (assoc (pre-submit-fn app-atom nil nil) :multi-cancel-reason multi-cancel-reason)
       :data (reduce #(assoc %1 :client-order/id %2) [] selected-row-ids)})))

(defmethod comms/receive :admin.wholesale/client-orders.cancel-sale-order [app-atom {:keys [action-key] :as e}]
  (datatables/overlay app-atom :close :admin.wholesale/client-orders.table)
  (grid/dispatch-action app-atom action-key (dissoc e :action-key)))

(defmethod grid/action :admin.wholesale/client-orders.multi-cancel [app-atom {:keys [msg rows] :as e}]
  (let [{:keys [success]} (editor/post-submit app-atom :admin.wholesale/client-orders.editor e)]
    (when success
      (toaster/open-toast app-atom :success msg {})
      (datatables/update-rows app-atom :admin.wholesale/client-orders.table {:rows rows}))))

(rum/defc filter-by-status < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        order-statuses (cmn/curact action-atom :client-order/statuses)
        order-status-filter-atom (rum/cursor-in action-atom [:status-filters])]
    [:div
     {:class (yuc/bem :flex-grid-group [:flush :valign-middle :align-left])}
     [:div
      {:class (yuc/bem :flex-grid-block [:ml-shrink-0 :ml-fluid])}
      [:div.flex-grid-content
       [:span
        [:i
         {:class
          (yuc/bem :icon [:filter :2-1 :in-copy-left :inline :default])}]
        [:b "Filter by status:"]]]]
     [:div
      {:class (yuc/bem :flex-grid-block [:ml-grow-yes :ml-fluid])}
      [:div.flex-grid-content
       [:div
        {:class
         (yuc/bem :flex-grid-group [:flush :valign-middle :align-left])}
        (map
          (fn [[_ wholesale-status]]
            [:div
             {:key wholesale-status
              :class (yuc/bem :flex-grid-block [:ml-fluid])}
             [:div.flex-grid-content
              (forms/checkbox wholesale-status (rum/cursor order-status-filter-atom wholesale-status)
                {})]])
          order-statuses)]]]]))

(rum/defc filter-by-date < rum/reactive [app-atom]
  (let [action (cmn/process-action-name app-atom)]
    [:div
     {:class (yuc/bem :flex-grid-group [:flush :align-left])}
     [:div
      {:class (yuc/bem :flex-grid-block [:ml-shrink-0 :valign-middle])}
      [:div
       {:class (yuc/bem :flex-grid-block [:ml-fluid])}
       [:span
        [:i
         {:class
          (yuc/bem :icon [:calendar :2-1 :in-copy-left :inline :default])}]
        [:b "Filter by date:"]]]

      [:div
       {:class (yuc/bem :flex-grid-block [:ml-fluid])}
       [:div.flex-grid-content
        (rum/with-key
          (w.cmn/form-date app-atom action :date-filters :from-date "From Date:"
            {:ignore-changes true})
          "filter-from-date")]]

      [:div
       {:class (yuc/bem :flex-grid-block [:ml-fluid])}
       [:div.flex-grid-content
        (rum/with-key
          (w.cmn/form-date app-atom action :date-filters :to-date "To Date:"
            {:ignore-changes true})
          "filter-to-date")]]]]))

(rum/defc client-orders-list < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        list-updated-at (cmn/curact action-atom :client-order/list-updated-at)]
    [:<>
     [:div.u-margin-bottom-30
      {:class (yuc/bem :card [:no-hover] :text-card [:small])}
      (filter-by-status app-atom)
      (filter-by-date app-atom)
      [:div
       {:class (yuc/bem :flex-grid-group [:flush :align-right])}
       [:div
        {:class (yuc/bem :flex-grid-block [:ml-shrink-0 :valign-middle])}


        [:div
         {:class (yuc/bem :flex-grid-block [:ml-order-01])}
         [:div.flex-grid-content
          [:b "Table last updated at: "]
          (when list-updated-at (yud/format-date list-updated-at "yyyy/MM/dd HH:mm"))]]

        [:div
         {:class (yuc/bem :flex-grid-block [:ml-fluid])}
         [:div.flex-grid-content
          (buttons/button-web "Filter"
            (merge
              (urlstate/href-on-click
                #(grid/dispatch-action app-atom :admin.wholesale/client-orders.filter {}))
              {}))]]]]]
     (datatables/table app-atom :admin.wholesale/client-orders.table (client-order-table-fns app-atom))
     (toaster/loading-overlay app-atom :admin.wholesale/client-order-list)]))

(defmethod grid/action :admin.wholesale/client-orders.filter [app-atom config _]
  (let [action-atom (cmn/action-cursor app-atom)
        order-status-filters (cmn/curact action-atom [:status-filters])
        filter-statuses (map key (filter (fn [[_ checked]] checked) order-status-filters))]
    (datatables/overlay app-atom :open :admin.wholesale/client-orders.table)
    (comms/send :admin.wholesale/client-orders.list {:filter-statuses filter-statuses})))

(defmethod t/transition-open :admin.wholesale/client_orders [app-atom _ params]
  (when-not (w.cmn/redirect-to-new-layout-if-needed! app-atom "wholesale.client_orders" params)
    (comms/send :admin.wholesale/client-orders.setup {})))

(defmethod comms/receive :admin.wholesale/client-orders.setup [app-atom e]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        date-filters (cmn/curact action-atom :date-filters)]
    (when (nil? date-filters)
      (swap! action-atom assoc :date-filters (:date-filters e)))
    (swap! process-atom assoc
      :dear-sync/method (:dear-sync/method e)
      :company/id (:company/id e)
      :default-warehouse (:default-warehouse e))))

(defmethod t/transition-after-open :admin.wholesale/client_orders [app-atom _ _]
  (let [action-atom (cmn/action-cursor app-atom)
        client-orders (cmn/curact action-atom :client-orders)]
    (dcommon/kill-search-bar)
    (presence/open app-atom {:context/ident :admin.wholesale/client-orders})
    (datatables/initiate app-atom (client-order-table-config app-atom) (client-order-table-fns app-atom))
    (when (empty? client-orders)
      (editor/initiate app-atom editor-config))))

(defmethod grid/action :admin.wholesale/client-orders.list [app-atom config _]
  (let [action-atom (cmn/action-cursor app-atom)
        order-status-filters (cmn/curact action-atom [:status-filters])
        filter-statuses (map key (filter (fn [[_ checked]] checked) order-status-filters))
        filter-dates (cmn/curact action-atom [:date-filters])]
    (datatables/overlay app-atom :open :admin.wholesale/client-orders.table)
    (comms/send :admin.wholesale/client-orders.list
      {:filter-statuses filter-statuses
       :filter-dates filter-dates})))

(defmethod comms/receive :admin.wholesale/client-orders.list
  [app-atom {:keys [options rows shipping-addresses-gpd billing-addresses-gpd]}]
  (datatables/overlay app-atom :close :admin.wholesale/client-orders.table)
  (let [action-atom (cmn/action-cursor app-atom)
        statuses (:client-order/statuses options)

        filter-statuses
        (->>
          statuses
          (filter (comp (set (:client-order/filter-statuses options)) first))
          (map (fn [[_ status]] [status true]))
          (into {}))]

    (swap! action-atom assoc
      :client-order/list-updated-at (dt/now)
      :client-order/statuses statuses
      :client-orders (yuc/index-by :client-order/id rows)
      :status-filters filter-statuses
      :shipping-addresses-gpd shipping-addresses-gpd
      :billing-addresses-gpd billing-addresses-gpd)

    (datatables/overlay app-atom :close :admin.wholesale/client-orders.table)
    (editor/post-comms app-atom :admin.wholesale/client-orders.editor {:options options})))

(defmethod flow/render-screen :admin.wholesale/client_orders [app-atom _]
  [:div {:style {:position "relative"}}
   [:div {:style {:position "absolute" :top 0 :right 0 :z-index 1}}
    (buttons/button-web "Try new layout"
      {:href "wholesale.htm?action=client_orders&v2=1"
       :on-click #(w.cmn/save-admin-layout-preference! app-atom "wholesale.client_orders" "new")
       :style :light
       :size :small})]
   (w.cmn/wholesale-wrapper app-atom
     {:main-page "Client Orders"
      :confirm-leave false
      :confirm-leave-modal-key :admin.wholesale/check.unsaved-changes}
     (client-orders-list app-atom))])


;;==========================================================================================
;;  RECONCILE REPORT
;;==========================================================================================

(defmethod grid/action :admin.wholesale/client-orders.open-reconcile-modal [app-atom _ _]
  (grid/multi-input-modal app-atom
    {:title "Reconcile report"
     :text
     [:p
      [:div "This report is only available to the Finance Team"]
      [:div "Please select a " [:b "Start"] " and " [:b "End"] " date that will be used to"]
      [:div "filter an order's invoiced date within the given period."]
      [:div "Please note this CSV is e-mailed to the group 'es.reconcile.client-orders' every 7 days in the month"]
      [:div "The user submitting this will be CC'd in the e-mail"]]
     :multi-modal-type :variable
     :save-key :admin.wholesale/client-orders.request-reconcile-report
     :inputs
     [{:field-text "Start Date"
       :input-key :start-date
       :input-type :datetime}
      {:field-text "End Date"
       :input-key :end-date
       :input-type :datetime}]}))

(defmethod grid/action :admin.wholesale/client-orders.request-reconcile-report [app-atom config _]
  (toaster/open-overlay app-atom :admin.wholesale/client-order-list)
  (comms/send :admin.wholesale/client-orders.reconcile-report
    {:from-date (:start-date config) :to-date (:end-date config)}))

(defmethod comms/receive :admin.wholesale/client-orders.reconcile-report [app-atom e]
  (toaster/close-overlay app-atom :admin.wholesale/client-order-list))
